import React, { useState, useEffect } from "react";
import {
    Col,
    Row,
    Card,
    CardBody,
    Container
} from "reactstrap";
import { apiEndpoint } from "helpers/url_helper";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";

const DeviceTable = (props) => {
    const [locationDetails, setLocationDetails] = useState([]);

    useEffect(() => {
        console.log("Selected Campus ID:", props.CampusID);

        
        const token = sessionStorage.getItem("Clear_AuthUser");
        console.log("Token from sessionStorage:", token);

        fetch(`${apiEndpoint}/getLocationDetails`, {
            method: "POST",  
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                strToken: token   
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log("API response:", data);


               
                const parsed = typeof data.LocationDetails === "string"
                    ? JSON.parse(data.LocationDetails)
                    : data.LocationDetails;

               
                const filtered = props.CampusID == 0
                    ? parsed
                    : parsed?.filter(item => Number(item.CampusID) === Number(props.CampusID));

                console.log("filtered data:", filtered);
                setLocationDetails(filtered || []);
            })
            .catch(error => {
                console.error("Error fetching location details:", error);
                setLocationDetails([]);
            });
    }, [props.CampusID]);

    const columns = [
        {
            dataField: "CampusName",
            text: "Campus",
            sort: true,
        },
        {
            dataField: "LocationName",
            text: "Location",
            sort: true,
        },
        {
            dataField: "LocationStatus",
            text: "Status",
            sort: true,
            formatter: (cell) => (
                <span style={{ color: cell === "Online" ? "green" : "red" }}>
                    {cell}
                </span>
            )
        },
        {
            dataField: "TimeStamp",
            text: "Last Updated",
            sort: true,
            formatter: (cell) => {
                const date = new Date(cell)
                return new Intl.DateTimeFormat('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true
                }).format(date);
            }
        }
    ];

    return (
        <React.Fragment>
            <Container fluid>
                <Row className="mt-3">
                    <Col>
                        <Card>
                            <CardBody>
                                <div className="table-responsive mt-2" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                    <ToolkitProvider
                                        keyField="LocationID"
                                        data={locationDetails}
                                        columns={columns}
                                    >
                                        {toolkitProps => (
                                            <BootstrapTable
                                                {...toolkitProps.baseProps}
                                                wrapperClasses="table"
                                            />
                                        )}
                                    </ToolkitProvider>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    );
};

export default DeviceTable;
